import { render, staticRenderFns } from "./cashback.vue?vue&type=template&id=0ab3ae51&scoped=true"
import script from "./cashback.vue?vue&type=script&lang=js"
export * from "./cashback.vue?vue&type=script&lang=js"
import style0 from "./cashback.vue?vue&type=style&index=0&id=0ab3ae51&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab3ae51",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/cashback.vue
// module id = XHZA
// module chunks = 0